import React, { useRef, useState, useEffect } from "react";

import Button from "./Button";
import "./ImageUpload.css";

const ImageUpload = (props) => {
  //console.log(props.val);
  //const [file, setFile] = useState();
  const [previewUrl, setPreviewUrl] = useState();
  const [isValid, setIsValid] = useState(false);

  const filePickerRef = useRef();

  useEffect(() => {
    if (!props.val) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result);
    };
    fileReader.readAsDataURL(props.val);
  }, [props.val]);

  const pickedHandler = (event) => {
    let pickedFile;
    let fileIsValid = isValid;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setIsValid(true);
      fileIsValid = true;
    } else {
      setIsValid(false);
      fileIsValid = false;
    }
    props.onInput(props.id, pickedFile, fileIsValid);
  };

  const deleteFile = (event) => {
    if (props.val) {
      setPreviewUrl();
      props.onInput(props.id, "", false);
    } else {
      //console.log("notDeleteImage");
    }
  };

  const pickImageHandler = () => {
    filePickerRef.current.click();
  };

  return (
    <div className="form-control">
      <input
        id={props.id}
        ref={filePickerRef}
        style={{ display: "none" }}
        type="file"
        accept=".jpg,.png,.jpeg"
        onChange={pickedHandler}
        /* imageUrl={props.imageUrl} */
      />
      <div className={`image-upload ${props.center && "center"}`}>
        <div className="image-upload__preview">
          <img
            src={
              previewUrl ||
              `https://ri2zqgv3xc.bnode.webrahost.ro/ueb/uploads/images/user.png`
            }
            alt="Preview"
          />
        </div>
        <Button type="button" disabled={props.val} onClick={pickImageHandler}>
          INCARCA POZA
        </Button>
        <Button danger type="button" disabled={!props.val} onClick={deleteFile}>
          <i className="fas fa-trash-alt"></i>
        </Button>
      </div>
      {!isValid && <p>{props.errorText}</p>}
    </div>
  );
};

export default ImageUpload;
